<template lang="html">
  <div class="fsd-email-sent columns small-10 medium-9 large-9">
    <svg-icon icon-name="modern-mail" class="fsd-email-sent__icon" />
    <div class="fsd-email-sent__text">
      {{ 'client.email_sent.text' | t({ email: email }) }}
    </div>
    <div v-if="type === 'registration'" class="fsd-email-sent__benefits">
      <div
        v-for="(benefit, key) in registrationBenefitKeys"
        :key="`benefit${key}`"
        class="fsd-email-sent__benefit"
      >
        <svg-icon icon-name="check-light" class="account-creation__check" />
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="fsd-email-sent__benefit-text account-creation__feature"
          v-html="benefit"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
    <div v-else class="fsd-email-sent__link">
      <a
        v-click-track="{
          event_element: 'email_sent',
          action_type: 'visit'
        }"
        class="ac-link ac-link--primary"
        @click="loginCurrentPageSet('passwordLogin')"
      >
        {{ 'client.email_sent.password_login_link' | t }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    type: { type: String, required: true }
  },
  data: () => ({
    registrationBenefits: [
      'client.email_sent.registration.benefits.profiles_html',
      'client.email_sent.registration.benefits.bookmarks_html',
      'client.email_sent.registration.benefits.articles_html'
    ]
  }),
  computed: {
    ...mapState(['login']),
    registrationBenefitKeys() {
      return this.registrationBenefits.map(key => this.$options.filters.t(key))
    },
    email() {
      return this.login[`${this.type}Email`] || ''
    }
  },
  methods: {
    ...mapActions(['loginCurrentPageSet'])
  }
}
</script>
